import { render } from "./SupportPage.vue?vue&type=template&id=cd094392&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"

import "./SupportPage.vue?vue&type=style&index=0&id=cd094392&scoped=true&lang=css"
import "./SupportPage.vue?vue&type=style&index=1&id=cd094392&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd094392"]])

export default __exports__